<ng-container *ngIf="isLoading; else viewSchedule">
  <div fxLayout="column" fxLayoutAlign="center center" style="height: 100vh">
    <uni-loader></uni-loader>
  </div>
</ng-container>
<ng-template #viewSchedule>
  <ng-container *ngIf="modules">
    <!-- <div class="width-100"> -->
      <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="20px" class="module-title-wrapper">
        <h3 class="font-lg font-bold spacing margin-0" >{{ modules.sub_heading | uppercase }} </h3>
        <mat-divider class="width-100 border-top-width-3"></mat-divider>
      </div>

      <div class="schedule-section" [ngClass.xs]="{'schedule-section-xs': true}">
        <div *ngIf="previous_deadlines.length > 0">
          <ng-container *ngFor="let deadline of previous_deadlines; let last=last">
            <div class="previous-timeline" [class.last-previous-timeline]="last && upcoming_deadlines.length==0">
              <div class="prev-deadline-container right">
                <div class="content" fxLayout="column" fxLayoutGap="8px">
                  <h4 class="font-sm font-regular margin-0 sparro-grey-800">{{ deadline.date | date : 'dd MMMM y, h:mm a' : 'UTC' }} UTC +0:00</h4>
                  <h4 class="font-sm font-bold margin-0 sparro-grey-800">{{ deadline.type }}</h4>
                </div>
              </div>
            </div>
          </ng-container>
        </div>

        <div class="upcoming" *ngIf="upcoming_deadlines.length > 0">
          <div class="upcoming-timeline" *ngFor="let deadline of upcoming_deadlines;">
            <div class="upcoming-deadline-container right">
              <div class="content" fxLayout="column" fxLayoutGap="8px">
                <h4 class="font-sm font-regular margin-0 sparro-grey-800">{{ deadline.date | date : 'dd MMMM y, h:mm a' : 'UTC' }} UTC +0:00</h4>
                <h4 class="font-sm margin-0 font-bold sparro-grey-900">{{ deadline.type }}</h4>
              </div>
            </div>
          </div>
        </div>

        <div  fxLayoutAlign="center center" *ngIf="modules.desc">
          <div class="desc" [innerHtml]="modules.desc"></div>
        </div>
      </div>
    <!-- </div> -->
  </ng-container>
</ng-template>
